import { DOCUMENT } from '@angular/common';
import { inject } from '@angular/core';
import { Router, ViewTransitionInfo, ViewTransitionsFeatureOptions } from '@angular/router';
import { getDeepestRouteSnapshot } from '@examdojo/angular/router';
import { PlatformService } from '@examdojo/platform';
import { ROUTES_WITH_DEFAULT_TRANSITION } from '../app.routes';
import { RouteTransition } from './route-transition.model';
import { slideRelativesTransition } from './transitions';

const TRANSITIONS: Array<(transitionInfo: ViewTransitionInfo) => string | boolean> = [slideRelativesTransition];

export const viewTransitionsConfig: ViewTransitionsFeatureOptions = {
  onViewTransitionCreated: ({ from, to, transition }) => {
    const router = inject(Router);
    const document = inject(DOCUMENT);
    const platformService = inject(PlatformService);

    const fromRouteSnapshot = getDeepestRouteSnapshot(from);
    const toRouteSnapshot = getDeepestRouteSnapshot(to);

    const targetUrlTree = router.getCurrentNavigation()!.finalUrl!;
    const targetUrl = targetUrlTree.toString();

    const currentNavigation = router.getCurrentNavigation();

    if (platformService.isIos && currentNavigation?.trigger === 'popstate') {
      // Prevent double animation with the browser navigation on iOS (button or gesture)
      transition.skipTransition();
      return;
    }

    document.documentElement.style.removeProperty('view-transition-name'); // Remove any existing transition name

    const transitionName = TRANSITIONS.reduce<string | boolean>((acc, fn) => {
      if (acc) {
        return acc;
      }
      return fn({ from: fromRouteSnapshot, to: toRouteSnapshot, transition });
    }, false);

    if (typeof transitionName === 'string') {
      document.documentElement.style.setProperty('view-transition-name', transitionName);

      // Reset the view-transition-name after the transition completes
      transition.finished.then(() => {
        document.documentElement.style.removeProperty('view-transition-name');
      });
      return;
    }

    const applyDefaultTransition =
      toRouteSnapshot.data['transition'] === RouteTransition.Default ||
      ROUTES_WITH_DEFAULT_TRANSITION.some((url) => `/${url}` === targetUrl);

    if (!applyDefaultTransition) {
      transition.skipTransition();
      return;
    }
  },
};
